const toNumber = (value) => {
  if (typeof value === "number") return value;
  if (value === null || value === undefined || value === "") return 0;
  const parsed = Number(String(value).replace(/\./g, "").replace(",", "."));
  return Number.isFinite(parsed) ? parsed : 0;
};

const defaultGetter = (field) => (row) => row?.[field];

export const buildFuelRowsWithDeltaKm = (rows = [], options = {}) => {
  const getId = options.getId || defaultGetter("id");
  const getPlate = options.getPlate || defaultGetter("vehiclePlate");
  const getDateKey = options.getDateKey || defaultGetter("date");
  const getOdometer = options.getOdometer || defaultGetter("odometerKm");
  const getStoredDelta = options.getStoredDelta || defaultGetter("deltaKm");

  const indexedRows = rows.map((row, index) => ({
    row,
    index,
    id: getId(row, index),
    plateKey: String(getPlate(row, index) || ""),
    dateKey: String(getDateKey(row, index) || ""),
    odometer: toNumber(getOdometer(row, index)),
    storedDelta: toNumber(getStoredDelta(row, index))
  }));

  const byPlate = new Map();
  indexedRows.forEach(item => {
    if (!item.plateKey) return;
    if (!byPlate.has(item.plateKey)) byPlate.set(item.plateKey, []);
    byPlate.get(item.plateKey).push(item);
  });

  byPlate.forEach(items => {
    items.sort((a, b) => {
      const byDate = a.dateKey.localeCompare(b.dateKey);
      return byDate || a.index - b.index;
    });

    let previousOdometer = null;
    items.forEach(item => {
      let computedKm = item.storedDelta;
      if (computedKm <= 0 && previousOdometer !== null && item.odometer > previousOdometer) {
        computedKm = item.odometer - previousOdometer;
      }
      item.computedKm = Number.isFinite(computedKm) && computedKm > 0 ? computedKm : 0;
      item.detailId = `${item.plateKey}|${item.dateKey}|${item.id || item.index}`;
      if (item.odometer > 0) previousOdometer = item.odometer;
    });
  });

  return indexedRows.map(item => ({
    ...item.row,
    _computedKm: item.computedKm || 0,
    _computedKmPlateKey: item.plateKey,
    _computedKmSourceIndex: item.index,
    _computedKmDetailId: item.detailId || `${item.plateKey}|${item.dateKey}|${item.id || item.index}`
  }));
};

export default buildFuelRowsWithDeltaKm;
